const allowedProtocols = new Set(['http:', 'https:']);

export const normalizePreviewUrl = (value: string): string | null => {
  const trimmedValue = value.trim();

  try {
    const url = new URL(trimmedValue);

    if (!allowedProtocols.has(url.protocol) || !url.hostname || url.username || url.password) {
      return null;
    }

    return trimmedValue.split('?', 1)[0].split('#', 1)[0];
  } catch {
    return null;
  }
};
